<template>
    <div id="register">
        <h1 class="title has-text-centered">ใบสมัครสมัครค่าย Hypercube 28</h1>
        <div v-if="!isConfirmed">
            <tabs animation="slide" :only-fade="false" class="is-full" style="width: 100%;">
                <tab-pane label="ประวัติส่วนตัว" selected>
                    <FirstProfileForm></FirstProfileForm>
                    <SecondRegisterForm></SecondRegisterForm>
                </tab-pane>
                <tab-pane label="ที่อยู่และการศึกษา">
                    <AddressForm></AddressForm>
                    <EducationForm></EducationForm>
                </tab-pane>
                <tab-pane label="แบบสอบถาม">
                    <SurveyForm></SurveyForm>
                </tab-pane>
            </tabs>
            <ControlButton class="is-pulled-right column"></ControlButton>
        </div>
        <section v-if="isConfirmed">
            <section class="hero is-primary is-medium">
                <div class="hero-body">
                    <div class="container has-text-centered">
                        <h1 class="title">
                            ยืนยันใบสมัครเเล้ว
                        </h1>
                        <h2 class="subtitle">
                            จริง ๆ อยากให้นั่งยันนอนยันได้ เเต่เเค่ยืนยันก็พอแล้ว <br>โปรดติดตามการประกาศผลได้ ผ่านทาง
                            facebook เเละ website ของพวกเรา
                        </h2>
                        <a class="button is-danger" @click="onLogOut">
                            Logout
                        </a>
                    </div>
                </div>
            </section>
        </section>

    </div>

</template>

<script>
    import FirstProfileForm from "@/components/FirstProfileForm";
    import {createOrGetUserData} from "@/firebaseUtil/firestoreUtil";
    import ControlButton from "@/components/ControlButton";
    import {Tabs, TabPane} from 'vue-bulma-tabs';
    import AddressForm from "@/components/AddressForm";
    import SecondRegisterForm from '@/components/SecondProfileForm';
    import EducationForm from "@/components/EducationForm";
    import SurveyForm from "@/components/SurveyForm";
    import LogoutButton from "@/components/LogoutButton"

    export default {
        name: "Register",
        components: {
            SurveyForm,
            EducationForm,
            SecondRegisterForm,
            AddressForm,
            FirstProfileForm,
            ControlButton,
            Tabs,
            TabPane,
        },
        async created() {
            const userId = this.$store.getters.user.uid;
            await createOrGetUserData(userId).then(result => {
                return this.$store.dispatch('setUserFormData', result);
            });
        },
        data: function () {
            return {}
        },
        methods: {
            async onLogOut() {
                await this.$store.dispatch('logout');
                alert('Log out successful');
                this.$router.replace('login');
            }
        },
        computed: {
            userFormData() {
                return this.$store.getters.userFormData;
            },
            isConfirmed() {
                return this.userFormData['confirmed'] !== false && this.userFormData['confirmed'] !== undefined
            }
        }
    }
</script>

<style scoped>
    #register {
        font-family: 'Prompt', sans-serif;
    }

    #logout-btn {
        width: 100%;
        margin: auto auto;
    }

</style>
